module.exports = __webpack_public_path__ + "static/link-cart-af747dfc363661afa27f57d38e1cbfec.png";